

export interface IMapDTO {
    id: number
    lataustunniste: string
    nimi: string
    oletussijainti: string
    url: string
};

export interface IMap {
    id: number
    name: string
    defaultPosition: string
    url: string
};



export const MapMapper = {
    apiToDomain: (api: IMapDTO): IMap => {
        return {
            id: api.id,
            name: api.nimi,
            defaultPosition: api.oletussijainti,
            url: api.url
        }
    }
};
